import React from "react";

function Service() {
  return (
    <section className="services" id="services">
      <div className="main-text">
        <h2>My Services</h2>
        <h4>Better Design, Better Expericences</h4>
      </div>

      <div className="services-content">
        <div className="box">
          {/* <img src='img/serv1.png' /> */}
          <h3>Front-End Developer</h3>
          <p>
            I provide top-notch services in front-end development with a focus
            on utilizing React, PHP, and Vue.js technologies. With my expertise
            in these frameworks, I can create engaging and responsive user
            interfaces that enhance the overall user experience. Leveraging
            React's component-based architecture, I develop dynamic and
            interactive web applications that seamlessly handle complex data
            flows. Additionally, my proficiency in PHP enables me to efficiently
            build server-side functionality and integrate it with the front-end,
            ensuring smooth communication between the two. Furthermore, my
            knowledge of Vue.js empowers me to craft scalable and performant
            user interfaces, taking advantage of its simplicity and reactivity.
            Through my front-end development services, I strive to deliver
            high-quality solutions that meet client requirements and exceed
            expectations.
          </p>
        </div>

        <div className="box">
          {/* <img src='img/serv2.png' /> */}
          <h3>Back-End Developer</h3>
          <p>
            I offer comprehensive backend development services utilizing a
            diverse skill set that includes Python, data science, machine
            learning, SQL, PostgreSQL, and Ruby on Rails. With Python as my
            primary language, I develop robust and scalable backend systems,
            leveraging its extensive libraries and frameworks. I have a deep
            understanding of data science and machine learning techniques,
            allowing me to incorporate intelligent algorithms into backend
            processes for advanced data analysis and predictive modeling.
            Proficiency in SQL and PostgreSQL enables me to design efficient and
            secure database architectures, ensuring seamless data management and
            retrieval. Furthermore, my expertise in Ruby on Rails empowers me to
            build web applications rapidly with its
            convention-over-configuration principle. Through my backend
            services, I provide reliable and high-performance solutions that
            optimize data processing, enhance system performance, and deliver
            exceptional user experiences.
          </p>
        </div>

        <div className="box">
          {/* <img src='img/serv3.png' /> */}
          <h3>Mobile App Developer</h3>
          <p>
            I specialize in Android development using two powerful
            cross-platform frameworks: React Native and Flutter. With React
            Native, I create robust and performant mobile applications that
            provide a native-like experience across both iOS and Android
            platforms. By leveraging a single codebase written in JavaScript, I
            ensure efficient development and faster time-to-market. React
            Native's rich UI components and extensive community support allow me
            to build visually appealing and responsive user interfaces. On the
            other hand, with Flutter, I harness the power of Dart programming
            language to create beautiful, natively compiled applications for
            Android. Flutter's hot-reload feature enables rapid prototyping and
            seamless debugging, resulting in a smooth development process.
            Whether it's React Native or Flutter, I possess the expertise to
            deliver high-quality Android applications that are user-friendly,
            visually stunning, and performant across a range of devices.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Service;
